export const actualizarEstadoAnexoFixture = {
  "ResponseCode": 200,
  "ResponseDetail": "Ok",
  "Result": {
    "__type": "UpdateObjectWorkviewResponse:#Consorcio.Transar.Entities.Services.HistoriaClinica",
    "Code": 0,
    "Description": "",
    "Result": "OK"
  }
};